import {JobType} from '../models/pos/jobType.model';

export class TypeNameUtils {
  public static getTypeNameSingular(type: JobType): string {
    switch (type) {
      case 'CLOSED_QUOTE':
        return 'Invoiced Quote';
      case 'INVOICE':
        return 'Invoice';
      case 'JOB':
        return 'Job';
      case 'QUOTE':
        return 'Quote';
    }
  }

  public static getTypeName(type: JobType): string {
    switch (type) {
      case 'CLOSED_QUOTE':
        return 'Invoiced Quotes';
      case 'INVOICE':
        return 'Invoices';
      case 'JOB':
        return 'Jobs';
      case 'QUOTE':
        return 'Quotes';
    }
  }

  public static getTypeList(): { name: string, value: string }[] {
    return [
      {
        name: 'Quotes',
        value: 'QUOTE'
      },
      {
        name: 'Invoices',
        value: 'INVOICE'
      }
    ];
  }
}
